/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
body {
  color: var(--black);
  font-family: var(--font-stack);
  font-size: 100%;
  line-height: 1.375;
  -webkit-font-smoothing: antialiased;
}

button,
input,
select,
textarea {
  font-family: var(--font-stack);
}

strong,
b {
  font-weight: 600;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
}

h1,
.h1 {
  font-size: 2.125em;
  font-weight: 600;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-bottom: 0.4411764706em;
}
p + h1, ul + h1, ol + h1, dl + h1, figure + h1, img + h1, table + h1, blockquote + h1,
p + .h1,
ul + .h1,
ol + .h1,
dl + .h1,
figure + .h1,
img + .h1,
table + .h1,
blockquote + .h1 {
  margin-top: 1.7647058824em;
}
@media only all and (max-width: 37.5em) {
  p + h1, ul + h1, ol + h1, dl + h1, figure + h1, img + h1, table + h1, blockquote + h1,
  p + .h1,
  ul + .h1,
  ol + .h1,
  dl + .h1,
  figure + .h1,
  img + .h1,
  table + .h1,
  blockquote + .h1 {
    margin-top: 1.7307692308em;
  }
  h2 + h1, .h2 + h1, h3 + h1, .h3 + h1, h4 + h1, .h4 + h1, h5 + h1, .h5 + h1, h6 + h1, .h6 + h1,
  h2 + .h1,
  .h2 + .h1,
  h3 + .h1,
  .h3 + .h1,
  h4 + .h1,
  .h4 + .h1,
  h5 + .h1,
  .h5 + .h1,
  h6 + .h1,
  .h6 + .h1 {
    margin-top: 1.1538461538em;
  }
}
@media only all and (max-width: 37.5em) {
  h1,
  .h1 {
    font-size: 1.625em;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.5769230769em;
  }
  p + h1, ul + h1, ol + h1, dl + h1, figure + h1, img + h1, table + h1, blockquote + h1,
  p + .h1,
  ul + .h1,
  ol + .h1,
  dl + .h1,
  figure + .h1,
  img + .h1,
  table + .h1,
  blockquote + .h1 {
    margin-top: 1.7307692308em;
  }
  h1 + h1, .h1 + h1, h3 + h1, .h3 + h1, h4 + h1, .h4 + h1, h5 + h1, .h5 + h1, h6 + h1, .h6 + h1,
  h1 + .h1,
  .h1 + .h1,
  h3 + .h1,
  .h3 + .h1,
  h4 + .h1,
  .h4 + .h1,
  h5 + .h1,
  .h5 + .h1,
  h6 + .h1,
  .h6 + .h1 {
    margin-top: 1.1538461538em;
  }
}

h2,
.h2 {
  font-size: 1.625em;
  font-weight: 600;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-bottom: 0.5769230769em;
}
p + h2, ul + h2, ol + h2, dl + h2, figure + h2, img + h2, table + h2, blockquote + h2,
p + .h2,
ul + .h2,
ol + .h2,
dl + .h2,
figure + .h2,
img + .h2,
table + .h2,
blockquote + .h2 {
  margin-top: 1.7307692308em;
}
h1 + h2, .h1 + h2, h3 + h2, .h3 + h2, h4 + h2, .h4 + h2, h5 + h2, .h5 + h2, h6 + h2, .h6 + h2,
h1 + .h2,
.h1 + .h2,
h3 + .h2,
.h3 + .h2,
h4 + .h2,
.h4 + .h2,
h5 + .h2,
.h5 + .h2,
h6 + .h2,
.h6 + .h2 {
  margin-top: 1.1538461538em;
}
@media only all and (max-width: 37.5em) {
  p + h2, ul + h2, ol + h2, dl + h2, figure + h2, img + h2, table + h2, blockquote + h2,
  p + .h2,
  ul + .h2,
  ol + .h2,
  dl + .h2,
  figure + .h2,
  img + .h2,
  table + .h2,
  blockquote + .h2 {
    margin-top: 1.3636363636em;
  }
}
@media only all and (max-width: 37.5em) {
  h2,
  .h2 {
    font-size: 1.375em;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.6818181818em;
  }
  p + h2, ul + h2, ol + h2, dl + h2, figure + h2, img + h2, table + h2, blockquote + h2, h1 + h2, .h1 + h2, h2 + h2, .h2 + h2, h4 + h2, .h4 + h2, h5 + h2, .h5 + h2, h6 + h2, .h6 + h2,
  p + .h2,
  ul + .h2,
  ol + .h2,
  dl + .h2,
  figure + .h2,
  img + .h2,
  table + .h2,
  blockquote + .h2,
  h1 + .h2,
  .h1 + .h2,
  h2 + .h2,
  .h2 + .h2,
  h4 + .h2,
  .h4 + .h2,
  h5 + .h2,
  .h5 + .h2,
  h6 + .h2,
  .h6 + .h2 {
    margin-top: 1.3636363636em;
  }
}

h3,
.h3 {
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-bottom: 0.6818181818em;
}
p + h3, ul + h3, ol + h3, dl + h3, figure + h3, img + h3, table + h3, blockquote + h3, h1 + h3, .h1 + h3, h2 + h3, .h2 + h3, h4 + h3, .h4 + h3, h5 + h3, .h5 + h3, h6 + h3, .h6 + h3,
p + .h3,
ul + .h3,
ol + .h3,
dl + .h3,
figure + .h3,
img + .h3,
table + .h3,
blockquote + .h3,
h1 + .h3,
.h1 + .h3,
h2 + .h3,
.h2 + .h3,
h4 + .h3,
.h4 + .h3,
h5 + .h3,
.h5 + .h3,
h6 + .h3,
.h6 + .h3 {
  margin-top: 1.3636363636em;
}
@media only all and (max-width: 37.5em) {
  h3,
  .h3 {
    font-size: 1.125em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.8333333333em;
  }
  p + h3, ul + h3, ol + h3, dl + h3, figure + h3, img + h3, table + h3, blockquote + h3, h1 + h3, .h1 + h3, h2 + h3, .h2 + h3, h3 + h3, .h3 + h3, h5 + h3, .h5 + h3, h6 + h3, .h6 + h3,
  p + .h3,
  ul + .h3,
  ol + .h3,
  dl + .h3,
  figure + .h3,
  img + .h3,
  table + .h3,
  blockquote + .h3,
  h1 + .h3,
  .h1 + .h3,
  h2 + .h3,
  .h2 + .h3,
  h3 + .h3,
  .h3 + .h3,
  h5 + .h3,
  .h5 + .h3,
  h6 + .h3,
  .h6 + .h3 {
    margin-top: 1.6666666667em;
  }
}

h4,
.h4 {
  font-size: 1.125em;
  font-weight: 500;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-bottom: 0.8333333333em;
}
p + h4, ul + h4, ol + h4, dl + h4, figure + h4, img + h4, table + h4, blockquote + h4, h1 + h4, .h1 + h4, h2 + h4, .h2 + h4, h3 + h4, .h3 + h4, h5 + h4, .h5 + h4, h6 + h4, .h6 + h4,
p + .h4,
ul + .h4,
ol + .h4,
dl + .h4,
figure + .h4,
img + .h4,
table + .h4,
blockquote + .h4,
h1 + .h4,
.h1 + .h4,
h2 + .h4,
.h2 + .h4,
h3 + .h4,
.h3 + .h4,
h5 + .h4,
.h5 + .h4,
h6 + .h4,
.h6 + .h4 {
  margin-top: 1.6666666667em;
}
@media only all and (max-width: 37.5em) {
  h4,
  .h4 {
    margin-bottom: 0.625em;
    font-size: 1em;
    line-height: 1.125;
  }
}

h5,
.h5 {
  font-size: 0.875em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
  margin-bottom: 1.0714285714em;
}
p + h5, ul + h5, ol + h5, dl + h5, figure + h5, img + h5, table + h5, blockquote + h5, h1 + h5, .h1 + h5, h2 + h5, .h2 + h5, h3 + h5, .h3 + h5, h4 + h5, .h4 + h5, h6 + h5, .h6 + h5,
p + .h5,
ul + .h5,
ol + .h5,
dl + .h5,
figure + .h5,
img + .h5,
table + .h5,
blockquote + .h5,
h1 + .h5,
.h1 + .h5,
h2 + .h5,
.h2 + .h5,
h3 + .h5,
.h3 + .h5,
h4 + .h5,
.h4 + .h5,
h6 + .h5,
.h6 + .h5 {
  margin-top: 2.1428571429em;
}

h6,
.h6 {
  font-size: 0.75em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
  margin-bottom: 1.25em;
}
p + h6, ul + h6, ol + h6, dl + h6, figure + h6, img + h6, table + h6, blockquote + h6, h1 + h6, .h1 + h6, h2 + h6, .h2 + h6, h3 + h6, .h3 + h6, h4 + h6, .h4 + h6, h5 + h6, .h5 + h6,
p + .h6,
ul + .h6,
ol + .h6,
dl + .h6,
figure + .h6,
img + .h6,
table + .h6,
blockquote + .h6,
h1 + .h6,
.h1 + .h6,
h2 + .h6,
.h2 + .h6,
h3 + .h6,
.h3 + .h6,
h4 + .h6,
.h4 + .h6,
h5 + .h6,
.h5 + .h6 {
  margin-top: 2.5em;
}

.lead-paragraph {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
@media only all and (max-width: 37.5em) {
  .lead-paragraph {
    font-size: 1.125em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
}

.superheading {
  margin-bottom: 0.4166666667em;
  font-size: 3em;
  font-weight: normal;
  line-height: 1.25;
}

p,
ul,
ol,
dl,
figure,
table,
blockquote {
  margin-top: 0;
  margin-bottom: 0.9375em;
}
p:last-child,
ul:last-child,
ol:last-child,
dl:last-child,
figure:last-child,
table:last-child,
blockquote:last-child {
  margin-bottom: 0;
}

p + ul,
p + ol {
  margin-top: -0.3125em;
}

ul ul,
ol ol,
ul ol,
ol ul {
  margin-top: 0.5em;
}

li {
  margin-bottom: 0.5em;
}
li:last-child, nav li {
  margin-bottom: 0;
}

a {
  border-width: 0;
  border-style: dotted;
  border-color: var(--pacific);
  color: var(--pacific);
  text-decoration: none;
}
a:visited, a.visited {
  border-color: var(--teal);
  color: var(--teal);
}
a:hover, a.hover {
  border-style: solid;
  border-color: var(--pacific-dark);
  color: var(--pacific-dark);
}
a:focus, a.focus {
  border-style: solid;
  outline: thin dotted;
  outline-offset: 1px;
}
a:active, a.active {
  border-style: solid;
  border-color: var(--navy);
  color: var(--navy);
}

p a,
li a,
dd a {
  border-bottom-width: 1px;
}

nav a {
  border-bottom-width: 0;
}

ul {
  padding-left: 1.125em;
  list-style: square;
}

ul ul {
  list-style-type: circle;
}

ol {
  padding-left: 1.3125em;
}
ol li:nth-last-child(n+10),
ol li:nth-last-child(n+10) ~ li {
  margin-left: 0.5625rem;
}

ol ol {
  list-style-type: lower-alpha;
}
ol ol li {
  margin-left: 0 !important;
}

ol ol ol {
  list-style-type: lower-roman;
}

nav ul,
nav ol,
nav ul ul,
nav ol ol {
  list-style: none;
  list-style-image: none;
}

caption {
  margin-bottom: 0.625em;
  text-align: left;
}

th,
td {
  padding: 0.625em;
}
thead th,
thead td {
  padding: 0.7142857143em;
  background: var(--gray-5);
  color: var(--black);
  font-size: 1em;
  vertical-align: top;
}

thead,
tbody tr {
  border-bottom: 1px solid var(--gray);
}

th {
  font-weight: 600;
  text-align: left;
}
thead th h2,
thead th .h2,
thead th h3,
thead th .h3,
thead th h4,
thead th .h4,
thead th h5,
thead th .h5,
thead th h6,
thead th .h6 {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  text-transform: inherit;
}

blockquote {
  margin-right: 0.9375em;
  margin-left: 0.9375em;
}
@media only all and (min-width: 37.5625em) {
  blockquote {
    margin-right: 1.875em;
    margin-left: 1.875em;
  }
}

img {
  max-width: 100%;
}

figure {
  margin-right: 0;
  margin-left: 0;
}
figure img {
  vertical-align: middle;
}

pre,
code {
  background: var(--gray-5);
  border-radius: 4px;
  color: var(--black);
  font-family: "Input Mono", Consolas, Monaco, "Courier New", monospace;
}

code {
  padding: 0.2307692308em 0.2307692308em 0;
  font-size: 0.8125em;
}

pre {
  display: block;
  padding: 0.625em 0.9375em;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
pre code {
  padding: 0;
  background-color: transparent;
}